"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreMenuGroup = exports.MoreMenuItem = exports.MoreMenu = void 0;
const react_1 = __importStar(require("react"));
const react_2 = __importDefault(require("@tippy.js/react"));
require("./Menu.pc.css");
const Menu_1 = require("./Menu");
const react_router_1 = require("react-router");
const MoreMenu = ({ children, disabled, secondary, secondaryButton, w1, testId, label, }) => {
    const [menuVisible, setMenuVisible] = (0, react_1.useState)(false);
    const onLabelClick = (0, react_1.useCallback)(() => !disabled && setMenuVisible(!menuVisible), [menuVisible]);
    return (react_1.default.createElement(react_2.default, { interactive: true, hideOnClick: true, className: "_pub-85e3db90_tippy-reset", trigger: "click", onHide: () => setMenuVisible(false), aria: null, role: "menu", appendTo: "parent", visible: menuVisible, distance: 0, animateFill: false, animation: "shift-toward", placement: "bottom-end", content: react_1.default.createElement(Menu_1.Menu, { w1: Boolean(w1), secondary: secondary, absolute: true, onClick: () => setMenuVisible(false) }, children) },
        react_1.default.createElement("span", null, label ? (react_1.default.createElement(Menu_1.MenuLabel, { onClick: onLabelClick, testId: testId }, label)) : (react_1.default.createElement(Menu_1.MenuButton, { testId: "open:menu", disabled: disabled, secondaryButton: secondaryButton, onClick: onLabelClick })))));
};
exports.MoreMenu = MoreMenu;
exports.MoreMenuItem = (0, react_1.memo)(({ href, onClick, checked, children, testId, danger }) => {
    const history = (0, react_router_1.useHistory)();
    const onClick2 = (0, react_1.useCallback)(() => {
        if (href) {
            history.push(href);
        }
        else if (onClick) {
            onClick();
        }
    }, [onClick]);
    return (react_1.default.createElement(Menu_1.MenuItem, { checked: checked, testId: testId, onClick: onClick2, danger: danger }, children));
});
exports.MoreMenuItem.displayName = 'MoreMenuItem';
exports.MoreMenuGroup = Menu_1.MenuItemGroup;
//# sourceMappingURL=MoreMenu.js.map